import React from 'react';
import { useCoinbaseWallet } from '../hooks/useCoinbaseWallet';

interface WalletConnectProps {
  onConnect: () => void;
  onDisconnect?: () => void;
}

const WalletConnect: React.FC<WalletConnectProps> = ({ onConnect, onDisconnect }) => {
  const {
    isConnected,
    address,
    isConnecting,
    error,
    connectWallet,
    disconnectWallet,
    isOnBaseNetwork,
    switchToBase
  } = useCoinbaseWallet();

  // Track the previous connection state so we notify the parent on each
  // transition exactly once — both connect and disconnect.
  const wasConnected = React.useRef(false);

  React.useEffect(() => {
    if (isConnected && !wasConnected.current) {
      wasConnected.current = true;
      onConnect();
    } else if (!isConnected && wasConnected.current) {
      wasConnected.current = false;
      onDisconnect?.();
    }
  }, [isConnected, onConnect, onDisconnect]);

  if (error) {
    return (
      <div className="wallet-error">
        <span>Error: {error}</span>
        <button onClick={connectWallet} className="wallet-connect-btn">
          Retry
        </button>
      </div>
    );
  }

  if (isConnected && address) {
    return (
      <div className="wallet-connected">
        {!isOnBaseNetwork && (
          <button onClick={switchToBase} className="wallet-switch-network-btn">
            Switch to Base
          </button>
        )}
        <span>Connected: {address.slice(0, 6)}...{address.slice(-4)}</span>
        <button onClick={disconnectWallet} className="wallet-disconnect-btn">
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <button 
      onClick={connectWallet} 
      disabled={isConnecting}
      className="wallet-connect-btn"
    >
      {isConnecting ? 'Connecting...' : 'Connect Coinbase Wallet'}
    </button>
  );
};

export default WalletConnect;